
import { useEffect, useState, useRef } from "react";
import { Check, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Success = () => {
  const [searchValue, setSearchValue] = useState("");
  const searchInputRef = useRef<HTMLInputElement>(null);

  const handleSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchValue.trim()) {
      const searchUrl = `http://api.pdfsearchhelper.com/api/search?q=${encodeURIComponent(searchValue.trim())}`;
      window.open(searchUrl, '_blank');
    }
  };

  useEffect(() => {
    // Set page title
    document.title = "Installed Search Safe Successfully!";

    // Send UTMs message when the page loads
    window.postMessage(
      {type: "SEND_UTMS", utms: localStorage.getItem('utms')}, "*"
    );

    // Focus the search input
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header with logo */}
      <div className="flex justify-center pt-12 pb-8">
        <img 
          src="/lovable-uploads/522d17fa-541b-46b2-aec6-aec8edf40b37.png" 
          alt="Search Safe Security" 
          className="h-20 w-auto"
        />
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col items-center justify-start px-4 max-w-2xl mx-auto w-full">
        <form onSubmit={handleSearchSubmit} className="w-full max-w-lg mb-8">
          <div className="relative">
            <input
              ref={searchInputRef}
              type="text"
              placeholder="Try a search now... add &quot;PDF&quot; for PDF-only results."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              className="w-full px-4 py-3 pr-12 text-gray-700 bg-white border border-gray-300 rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <button 
              type="submit"
              className="absolute right-3 top-1/2 transform -translate-y-1/2 p-2 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <Search className="w-5 h-5" />
            </button>
          </div>
        </form>

        {/* Success message */}
        <div className="w-full max-w-lg bg-green-50 border border-green-200 rounded-lg p-6 mb-8">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0">
              <Check className="w-5 h-5 text-green-600 mt-0.5" />
            </div>
            <div>
              <h2 className="text-green-800 font-medium text-sm mb-1">
                PDF Search Helper extension has been added successfully!
              </h2>
              <p className="text-green-700 text-xs">
                You can now search the web and find PDFs very quickly when you type the word PDF with your search query.
              </p>
            </div>
          </div>
        </div>

      </div>

      {/* Footer */}
      <div className="border-t border-gray-200 py-6">
        <div className="flex justify-center gap-8 text-sm text-gray-600">
          <a href="/" className="hover:text-gray-900 transition-colors">
            Home
          </a>
          <a href="/privacy" className="hover:text-gray-900 transition-colors">
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  );
};

export default Success;
